import React from 'react';

import { addBlog } from '../../../data/serviceBlogs';
import { hideMessage, hidePopup, showMessage } from '../../../helpers/uiFunctions/uiActions';

class NewBlogForm extends React.Component {
    add(newName, newStartDate) {
        showMessage("Adding New Blog...");
		var body = {
			"name": document.getElementById(newName).value,
			"startDate": document.getElementById(newStartDate).value,
		}
		addBlog(body).then(data => {
            hideMessage(data.success);
			if (data.success === true) {
				var update = this.state.blogs;
				update.unshift(data.result);
				this.setState({blogs: update});
				hidePopup('addBlogForm');
			}
		})
	}
    render() {
        return(
            <section className="section">
                <form className="form popup-form" id="addBlogForm" style={{display: 'none'}}>
                    <i className="fas fa-times icon" onClick={() => hidePopup("addBlogForm")} style={{float: 'right'}}></i>
                    <h3>Add New Blog</h3>
                    <p className="blog-error"></p>
                    <div className="input-row">
                        <input type="text" className="input" id="blogName" placeholder="Blog Title" />
                    </div>
                    <div className="input-row">
                        <label>Publish Date</label>
                        <input type="date" id="blogStart" name="blogStart" />
                    </div>
                    <input type="button" className="button is-info" onClick={() => this.add("blogName", "blogStart")} value="Add Blog" />
                </form>
            </section>
        )
    }
}
export default NewBlogForm;


// WEBPACK FOOTER //
// ./src/component_blog/components/BlogExplorer/NewBlogForm.js